export const SET_SKILLSSET_DATA = 'SET_SKILLSSET_DATA';
export const SET_SKILLSSET_SKILLS = 'SET_SKILLSSET_SKILLS';
export const SET_SKILLSET_SKILL_DATA = 'SET_SKILLSET_SKILL_DATA';
export const CREATE_SKILL_SET = 'CREATE_SKILL_SET';
export const SET_CUREENT_SERVICE_OPERATIONS = 'SET_CUREENT_SERVICE_OPERATIONS';
export const SET_SKILL_SERVICES = 'SET_SKILL_SERVICES';
export const SET_CURRENT_SKILL = 'SET_CURRENT_SKILL';
export const SET_CURRENT_SKILL_NODES = 'SET_CURRENT_SKILL_NODES';
export const SET_CURRENT_NODE_OPERATION = 'SET_CURRENT_NODE_OPERATION';
export const UPDATE_SKILL_NODE = 'UPDATE_SKILL_NODE';
export const ADD_SKILL_NODE = 'ADD_SKILL_NODE';
export const CREATE_SKILL = 'CREATE_SKILL';
export const SET_SKILL_TEMPLATES = 'SET_SKILL_TEMPLATES';
export const SET_SKILL_TEMPLATE_NODE = 'SET_SKILL_TEMPLATE_NODE';
export const CREATE_EMPTY_SKILL = 'CREATE_EMPTY_SKILL';
export const SET_SERVICE_OPERATIONS = 'SET_SERVICE_OPERATIONS';
export const DELETE_SKILL_NODE = 'DELETE_SKILL_NODE';

export const SET_FIELDS = 'SET_FIELDS';

//cards

export const GET_CARDS = 'GET_CARDS';
export const GET_TEMPLATE_CARDS = 'GET_TEMPLATE_CARDS';
export const SAVE_CARDS = 'SAVE_CARDS';
export const DELETE_CARD = 'DELETE_CARD';
export const UPDATE_CARD = 'UPDATE_CARD';
export const UPDATE_CARD_SKILLS = 'UPDATE_CARD_SKILLS';
//Card_Skills
export const DELETE_CARD_SKILL = 'DELETE_CARD_SKILL';
export const SAVE_CARD_SKILLS = 'SAVE_CARD_SKILLS';

export const GET_USER_INFO = 'GET_USER_INFO';
export const SET_EPICS = 'SET_EPICS';
export const ADD_EPICS = 'ADD_EPICS';

export const SET_CARD_SKILLS = 'SET_CARD_SKILLS';
export const ADD_CARD_SKILL = 'ADD_CARD_SKILL';

export const HANDLE_PROJECTS = 'HANDLE_PROJECTS';
